export const Fetcher= async ({dispatch,data})=>{
    try{
        const response = await fetch('https://avengerapi.onrender.com'+data)
        //https://avengerapi.onrender.com
       if(!response.ok){
        throw new Error(`HTTP ERROR ${response.status}`)
       }
       const responsedata = await response.json()
      dispatch({type:'success',payload:responsedata})
    }
    catch(err){
        dispatch({type:'failed',errormessage:err.message})
    }
}


export const  Moviename=({dispatch})=>{
let data = '/MovieName'
Fetcher({dispatch,data})
}


export const  WatchedMovies=({dispatch})=>{
    let data = '/Mostwatched'
    Fetcher({dispatch,data})
}


export const  favourite=({dispatch})=>{
    let data = '/Favourite'
    Fetcher({dispatch,data})
}


export const  Moviedis=({dispatch,movieid})=>{
    let data = '/Allmovie?id='+movieid
    Fetcher({dispatch,data})
}

export const Cate=({dispatch,categoriesid})=>{
    let data = '/Allmovie?catId='+categoriesid
    Fetcher({dispatch,data})
}

export const Allmov=({dispatch})=>{
    let data = '/Allmovie'
    Fetcher({dispatch,data})
}